import { Component, EventEmitter, Input, Output, Pipe, PipeTransform } from "@angular/core";
import { ClareServicePlan } from "@app/project/model/clare-service-plan";
import { Project } from "@app/project/model/project";
import { ServicePlanFeature } from "@app/project/model/service-plan-feature";
import { ServicePlanUtils } from "@app/project/services/service-plan-utils";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "price" })
export class PricePipe implements PipeTransform {
    transform(value: string, term: string = "mo"): string {
        return value === "$0.00" ? "Free" : value + "/" + term;
    }
}

@Component({
    selector: "app-service-plan-table",
    templateUrl: "./service-plan-table.component.html",
    styleUrls: ["./service-plan-table.component.scss"],
})
export class ServicePlanTableComponent {
    @Input() availablePlans: ClareServicePlan[];
    @Input() availablePlanFeatures: ServicePlanFeature[];
    @Input() project: Project;
    @Input() isDialog = false;
    @Input() currentPlan: ClareServicePlan;
    @Output() selectedPlan: EventEmitter<ClareServicePlan> = new EventEmitter<ClareServicePlan>();

    constructor(private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {
        matIconRegistry.addSvgIcon("checkmark-new", domSanitizer.bypassSecurityTrustResourceUrl("assets/images/checkmark-new.svg"));
    }

    checkFeatures(plan: ClareServicePlan, feature: ServicePlanFeature) {
        return plan.features.some(planFeature => planFeature.featureName === feature.featureName);
    }

    getColor(plan) {
        return ServicePlanUtils.color(plan);
    }

    getIconColor(plan): string{
        return ServicePlanUtils.smallIconColor(plan);
    }

    openServicePlanOptions(plan: ClareServicePlan) {
        this.selectedPlan.emit(plan);
    }
}
